"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { createRichTextOptions } from "@/lib/formatters/formatRichText";
import { DEFAULT_PUBLIC_LANG } from "@/lib/locale/toContentfulLocale";
import { normalToMachineTheme } from "@/lib/utils";
import { ThemeDivider } from "@/components/terra/component/ThemeDivider/ThemeDivider";
import { LayoutRichText } from "@/components/terra/layouts/LayoutRichText/LayoutRichText";
export default function MXPLayoutRichText(props) {
  const $ = _c(19);
  const {
    value,
    index,
    divider,
    headerElement,
    lang: t0
  } = props;
  const lang = t0 === undefined ? DEFAULT_PUBLIC_LANG : t0;
  let t1;
  if ($[0] !== lang || $[1] !== value) {
    const richTextOptions = createRichTextOptions(lang, value?.richText?.links);
    t1 = value?.richText?.json ? documentToReactComponents(value.richText.json, richTextOptions) : undefined;
    $[0] = lang;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const body = t1;
  const t2 = value?.theme;
  let t3;
  if ($[3] !== t2) {
    t3 = normalToMachineTheme(t2);
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const presetTheme = t3;
  const t4 = value?.eyebrow;
  const t5 = value?.title;
  let t6;
  if ($[5] !== body || $[6] !== headerElement || $[7] !== index || $[8] !== presetTheme || $[9] !== t4 || $[10] !== t5) {
    t6 = <LayoutRichText eyebrow={t4} title={t5} headerElement={headerElement} body={body} index={index} presetTheme={presetTheme} />;
    $[5] = body;
    $[6] = headerElement;
    $[7] = index;
    $[8] = presetTheme;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== divider || $[13] !== presetTheme) {
    t7 = divider && <div className={`section-divider-wrap ${presetTheme}`}><ThemeDivider currentTheme={presetTheme} /></div>;
    $[12] = divider;
    $[13] = presetTheme;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== index || $[16] !== t6 || $[17] !== t7) {
    t8 = <React.Fragment key={index}>{t6}{t7}</React.Fragment>;
    $[15] = index;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}